import {EventBus, RESET} from '~/utils/event-bus'
import {clearRecentJsErrors, recordJsError} from '~/utils/recent-js-errors'

// Records the latest front-end exceptions for the Report Issue link (AIO-373, 3.1).
// Only observes: Nuxt keeps its own error handling (error page, showError) untouched.
export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.hook('vue:error', error => recordJsError(error))
    window.addEventListener('error', event => {
        // Resource load failures reach window only in capture phase, but stay defensive
        if (event.error || event.message) recordJsError(event.error ?? event.message)
    })
    window.addEventListener('unhandledrejection', event => recordJsError(event.reason))
    // AuthStore.logOut() emits RESET; subscribing here keeps mods/ copies of the store in sync
    EventBus.$on(RESET, clearRecentJsErrors)
})
